module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "middle-box text-center loginscreen animated fadeInDown"
  }, [_c('div', [_c('div', [_c('h1', {
    staticClass: "f75"
  }, [_c('a', {
    staticStyle: {
      "color": "#e6e6e6"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/cgd/by')
      }
    }
  }, [_vm._v(_vm._s(_vm.$store.state.appShortName))])])]), _vm._v(" "), _c('h2', {
    staticClass: "mt20"
  }, [_vm._v("欢迎登录" + _vm._s(_vm.$store.state.appShortName))]), _vm._v(" "), _c('div', {
    staticClass: "mt40"
  }, [_c('div', {
    staticClass: "input-group m-b"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group m-b"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.captcha && _vm.captcha.visible) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-7"
  }, [_c('div', {
    staticClass: "input-group m-b"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.captcha.value),
      expression: "captcha.value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.captcha.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.captcha, "value", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5"
  }, [_c('NbCaptcha', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "captcha": _vm.captcha
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.errorMessage),
      expression: "user.errorMessage"
    }],
    staticClass: "alert alert-danger text-left"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.user.errorMessage) + "\n\n\t\t\t")]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-primary block full-width m-b",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登录")])])]), _vm._v(" "), _c('p', {
    staticClass: "m-t"
  }, [_c('small', [_vm._v(_vm._s(_vm.$store.state.appName) + " © 2017")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-envelope w14"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-unlock-alt w14"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-image w14"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-42eebe33"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/lobby/view/user/Login.vue
// module id = 975
// module chunks = 1